require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./wob-module-1-event-report.json") })
        }
      }, "path---wob-module-1-event-report");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---wob-module-1-event-report!./.cache/json/wob-module-1-event-report.json
// module id = 1278
// module chunks = 231608221292675